import { useState, useCallback } from "react";
import posthog from "posthog-js";

import { useAppDispatch } from "store/hooks";
import { setNotification } from "store/features/notificationSlice";
import { downloadSvgAsPng, downloadSvg } from "shared/functions/imageHelpers";

export const useQrDownloader = () => {
  const dispatch = useAppDispatch();

  const [isDownloading, setIsDownloading] = useState(false);

  const downloadQrAsPng = useCallback(
    async (elementId: string, fileName: string = "ibanoplata-qr-code.png") => {
      setIsDownloading(true);

      await new Promise((r) => setTimeout(r, 100));

      try {
        await downloadSvgAsPng({ svgId: elementId, fileName });
      } catch (error) {
        posthog.captureException(error, {
          context: "QR Code Download Failed",
        });

        dispatch(
          setNotification({
            severity: "error",
            message: "Помилка завантаження QR-коду",
          }),
        );
      } finally {
        setIsDownloading(false);
      }
    },
    [dispatch],
  );

  const downloadQrAsSvg = useCallback(
    async (elementId: string, fileName: string = "ibanoplata-qr-code.svg") => {
      setIsDownloading(true);

      await new Promise((r) => setTimeout(r, 100));

      try {
        await downloadSvg(elementId, fileName);
      } catch (error) {
        posthog.captureException(error, {
          context: "QR Code SVG Download Failed",
        });

        dispatch(
          setNotification({
            severity: "error",
            message: "Помилка завантаження QR-коду",
          }),
        );
      } finally {
        setIsDownloading(false);
      }
    },
    [dispatch],
  );

  return { isDownloading, downloadQrAsPng, downloadQrAsSvg };
};
